<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="15.998"
    viewBox="0 0 16 15.998"
  >
    <g id="Group_952" data-name="Group 952" transform="translate(-78 -82.376)">
      <path
        id="Path_461"
        data-name="Path 461"
        d="M19.681,15.334a4.347,4.347,0,1,0,4.347,4.347A4.352,4.352,0,0,0,19.681,15.334Zm1.884,3.505-2.174,2.508a.5.5,0,0,1-.361.173h-.018a.5.5,0,0,1-.355-.146L17.486,20.2a.5.5,0,0,1,.709-.709l.79.79,1.821-2.1a.5.5,0,0,1,.759.657Z"
        transform="translate(69.972 74.346)"
        fill="#fff"
        opacity="0.3"
      />
      <g
        id="Group_951"
        data-name="Group 951"
        transform="translate(78 82.376)"
        opacity="0.5"
      >
        <path
          id="Path_462"
          data-name="Path 462"
          d="M19.878,11.953,14.233,8.067a.383.383,0,0,0-.428,0L8.161,11.953A.375.375,0,0,0,8,12.261v6.9a.879.879,0,0,0,.876.876h1.632V13.892a.377.377,0,0,1,.374-.374h6.273a.378.378,0,0,1,.374.374v.562a5.633,5.633,0,0,1,2.175-.434c.113,0,.221,0,.334.007V12.261a.375.375,0,0,0-.161-.308Z"
          transform="translate(-8 -8.002)"
          fill="#fff"
        />
        <path
          id="Path_463"
          data-name="Path 463"
          d="M11.253,14.247v1h4.883a4.942,4.942,0,0,1,.629-.434v-.569Z"
          transform="translate(-7.99 -7.982)"
          fill="#fff"
        />
        <path
          id="Path_464"
          data-name="Path 464"
          d="M11.253,16v1.251h3.3a5.354,5.354,0,0,1,.8-1.251Z"
          transform="translate(-7.99 -7.976)"
          fill="#fff"
        />
        <path
          id="Path_465"
          data-name="Path 465"
          d="M11.253,14.247v1h4.883a4.942,4.942,0,0,1,.629-.434v-.569Z"
          transform="translate(-7.99 -7.982)"
          fill="#fff"
        />
        <path
          id="Path_466"
          data-name="Path 466"
          d="M11.253,16v1.251h3.3a5.354,5.354,0,0,1,.8-1.251Z"
          transform="translate(-7.99 -7.976)"
          fill="#fff"
        />
        <path
          id="Path_467"
          data-name="Path 467"
          d="M14.257,18a5.881,5.881,0,0,0-.234,1.251H11.254V18Z"
          transform="translate(-7.99 -7.97)"
          fill="#fff"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "realization-icon",
};
</script>
